// Module
var code = `<div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <h5 class="modal-title">{{ description }}</h5>
</div>
<amt-form-inline schema-form="schema_form" extend-model="extend_model" on-submit="onSubmit(form, model)">
</amt-form-inline>
`;
// Exports
module.exports = code;